export default __webpack_public_path__ + "71ef49de11b8b828599a54a56f702af3.png";